import { IFormState } from '../types/calculator';
import {
  EBenefitProgram,
  EEmploymentType,
  EIncomeConfirmation,
  EObjectType,
  ERealEstateType,
} from '../types/calculator/enums';

/**
 * TODO оставлю пока как fallback-значения, чтобы не опираться на фичатогл. При рефакторинге - выпилить
 * */
export const DEFAULT_FORM_STATE = {
  regionId: '1',
  realEstateType: ERealEstateType.NewBuilding,
  objectType: EObjectType.Flat,
  loanTerm: 30,
  objectCost: 6_000_000,
  downPayment: 1_800_000,
  benefitProgram: EBenefitProgram.NoProgram,
  typeOfEmployment: EEmploymentType.Employee,
  incomeConfirm: EIncomeConfirmation.Confirmation,
  lifeInsurance: true,
} as IFormState;
